import { jsx as _jsx } from "react/jsx-runtime";
import styles from "./sk-CardContainer.module.css";
export const CardContainer = ({ children, isResponsive = false }) => isResponsive ? _jsx("div", { className: styles.container, children: children }) : children;
CardContainer.displayName = "CardContainer";
//# sourceMappingURL=CardContainer.js.map